<template>
  <div>
    <div v-if="pjnoticeList.length>1">
      <div v-if="pjnoticeList.length>0" style="margin:20px 20px;">
        <vggrid :list="pjnoticeList" tableheight="600" flexname="" :cols="cols"
                @cellDblClick="viewProject" :showfooter="false" :showPage="true" :resizable="true"
                :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
                @vggridClick="vggridClick"
        >
              <template slot="btn">
                <div class="btn-box">
                </div>
              </template>
        </vggrid>
      </div>
    </div>
    <div v-else-if="pjnoticeList.length === 1">
      <div  style="margin:90px 30px;">
        <div class="other-content" id="px" ref="px" v-if="model">
          <div class="title">
            {{model.pjnoticetitle}}
          </div>
          <div class="line1"></div>
          <div class="content">
            <div  v-html="model.pjnoticedesc"></div>
          </div>
          <div class="line" v-if="model.pjnoticedesc"></div>
          <div v-if="model.appendList && model.appendList.length" class="filelist">
            <div v-for="(item,index) in model.appendList" :key="index" class="fileitem">
              <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a></div>
            </div>
          </div>
        </div>
        <div v-else>
          无
        </div>
      </div>
    </div>
    <div v-else>
        无
    </div>
  </div>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  export default {
    name: 'announCList',
    data () {
      return {
        pjnoticeList: {},
        model:{},
        pjnotice:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'pjnoticetypedesc',fieldtype: 'C', title: '类型',calculExpr:'',addNewRowFlg: false, width: 100 },
          { field: 'pjnoticetitle', fieldtype: 'C', title: '主题',calculExpr:'',addNewRowFlg: false},
          { field: 'pjnoticestatusname', fieldtype: 'C', title: '状态',calculExpr:'', width: 80,addNewRowFlg: false, width: 100 },
          { field: 'pjnoticetime', fieldtype: 'C', title: '发布时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', ''], width: 180 }
        ],
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
    },
    activated() {
    },
    mounted () {
      this.getPageList()
    },
    watch: {
      '$route.query.Ptype':async function(newVal,oldVal){
        if(newVal != oldVal){
                this.getPageList()
        }
      }
    },
    computed: {},
    components: {vggrid},
    methods: {
      async getPageList () {
        this.query.pjnoticeprojectid = this.$route.query.projectid
        this.query.pjnoticetype = 2
        let res = await request({
          method: 'get',
          url: '/xmgl/pjnotice/getPageList',
          params: this.query
        })
        this.pjnoticeList = res.list
        this.query.total = res.count[0].count
        if(this.pjnoticeList.length === 1){
          await this.getModel()
        }
      },
      vggridClick(code,row){
        this.pjnotice = row
        this.$emit(code,row)
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async cellClick (row) {
        this.pjnotice = row.row
      },
      async viewProject(row) {
        this.pjnotice = row.row
        this.$router.push({name: 'pjnoticeFile', query: {Ptype: 2,projectid:this.$route.query.projectid}})
      },
      async getModel () {
        let cosid = this.$store.getters.loginUser.cosid?this.$store.getters.loginUser.cosid:this.$store.getters.expertLoginUser.cosid
        let id = this.$route.params.projrctid?this.$route.params.projrctid:this.$route.query.projectid,
            type = this.$route.params.Ptype?this.$route.params.Ptype:this.$route.query.Ptype
        let res = await request({
          method: 'get',
          url: '/xmgl/pjnotice/getPJNoticeListByprojectId',
          params: {projectid:id,
          pjnoticetype:type,
          cosid:cosid}
        })
        this.model = res
      }
    }
  }
</script>
<style lang="scss">
  .other-content {
    display: flex;
    flex-direction: column;
    // align-items: center;
    /*width: 100vw;*/
    /*height: 100vh;*/

    // overflow: auto;
    // font-weight: normal;
    // font-weight: lighter;
    .title {
      text-align: center;
      font-size: 22px;
      color: #000;
      word-wrap: break-word;
      // font-weight: lighter;
    }
    .desc {
      display: flex;
      justify-content: space-between;
      color: #000;
      font-size: 14px;
      line-height: 18px;
      text-align: left;
      margin: 10px 0
    }
    .line, .line1 {
      width: 100%;
      background: #000;
    }
    .line {
      height: 1px;
      margin-bottom: 4px
    }
    .line1 {
      height: 1px;
    }
    .content {
      padding: 10px 20px;
      // line-height: 28px;
    }
    .filelist {
      /*width: 100%;*/
      padding-top: 10px;
      .fileitem {
        display: flex;
        text-align: left;
        line-height: 25px;
        .name {
          color: #2f74ff;
          cursor: pointer;
        }
      }
    }
  }
</style>
